<template>
  <text-editor
    ref="editor"
    :id="'editor' + item.id"
    :class="['pa-1', !borderColor ? 'border-none' : '']"
    :tabindex="index"
    :text="item.description"
    :disabled="$store.state.isWorkflowDisabled"
    @text-update="updateDescription"
    @move-focus="moveFocus"
    :borderColor="borderColor"
  />
</template>

<script>
import workflowApi from '@/api/workflowApi'
import TextEditor from '@/components/TextEditor.vue'
import { EventBus } from '@/event-bus/event-bus.js'
import requirementTypesApi from '@/api/requirementTypesApi'

export default {
  props: {
    item: Object,
    index: Number,
    focusCard: String,
    scrollIntoViewArg: Boolean
  },

  components: {
    TextEditor
  },

  computed: {
    borderColor () {
      return this.item && this.item.cardType && this.item.cardType.triggerType
        ? requirementTypesApi.getBackgroundColour(this.item.cardType)
        : ''
    }
  },

  methods: {
    updateDescription (html) {
      workflowApi.updateRequirementsJsonMutation(this.$route.params.id, [{ requirementId: this.item.id, description: html }])
    },

    focusOnCard (id) {
      if (this.item?.id === id) {
        this.$el.scrollIntoView(this.scrollIntoViewArg)
        this.$el.focus()
        this.$refs.editor.setCaretAtEndOfEditor()
      }
    },

    moveFocus (direction, target, className) {
      this.$emit('move-focus', direction, target, className)
    }
  },

  watch: {
    focusCard: function (id) {
      this.focusOnCard(id)
    }
  },

  mounted () {
    if (!this.$store.state.isWorkflowDisabled) {
      EventBus.$on('focus-card', card => {
        this.$nextTick(() => {
          this.focusOnCard(card.id)
        })
      })
    }
  },
  beforeUnmount () {
    EventBus.$off('focus-card')
  }
}
</script>

<style>
.description p {
  margin-bottom: 0px !important;
  color: black;
}

.ql-editor {
  user-select: text;
}
</style>
